module.exports = __webpack_public_path__ + "img/img.abe22eaa.png";